export default __webpack_public_path__ + "static/media/tapicerowane7.ae35bd63.jpg";